import type { FC } from 'react';
import { PulseButton } from '@anywayseo/tools';
import { DownloadIcon } from '@chakra-ui/icons';
import { Button, Flex, Text } from '@chakra-ui/react';
import type { Locale, Localized } from 'content/data';
import { REF_LINK } from 'content/data';
import { useCtaContext } from 'components/cta-provider';

const DownloadButtonLabelMap: Localized<string> = {
  en: 'Download',
  de: 'Download',
};

const SignUpButtonLabelMap: Localized<string> = {
  en: 'Sign Up',
  de: 'ANMELDEN',
};

type HeaderToolbarProps = {
  locale: Locale;
};

export const HeaderToolbar: FC<HeaderToolbarProps> = ({ locale }) => {
  const { openCasinoAlternativesModal } = useCtaContext();

  const isDe = locale === 'de';
  const downloadButtonProps = isDe ? { as: 'a' as const, href: REF_LINK } : { onClick: openCasinoAlternativesModal };

  return (
    <Flex gap={2} align='center'>
      <Button aria-label='Download' h='100%' {...downloadButtonProps}>
        <DownloadIcon />
        <Text display={{ base: 'none', md: 'block' }} ms={2}>
          {DownloadButtonLabelMap[locale]}
        </Text>
      </Button>
      {isDe ? (
        <PulseButton label={SignUpButtonLabelMap[locale]} colorScheme='dark' to={REF_LINK} />
      ) : (
        <PulseButton label={SignUpButtonLabelMap[locale]} colorScheme='dark' onClick={openCasinoAlternativesModal} />
      )}
    </Flex>
  );
};
